export default __webpack_public_path__ + "static/media/in.e48df9d0.png";